
import PulseItem from 'pages/pulse/feed/feed-item.vue'
import {API2_PULSE} from 'consts/api2'
import Rest from 'utils/rest'

export default {
  components: {
    PulseItem
  },
  props: {
    data: {type: Object, required: true},
    mode: {type: String, default: 'expanded'},
    copiedTitle: {type: Boolean, default: false},
  },
  emits: ['prompt-save'],
  data(){
    return {
      pulse_item: undefined,
      show_pulse: !!this.data.pulse_feed_id
    }
  },
  computed: {
    text(){
      const title = this.data.title || this.data.text || this.data
      if (this.copiedTitle) return `Copy of ${title}`
      return title 
    },
  },
  async mounted(){
    if (this.show_pulse) {
      try {
        const rest = new Rest()
        this.pulse_item = await rest.get(`${API2_PULSE}/${this.data.pulse_feed_id}`)
      } catch (err) {
        console.log(err)
        this.show_pulse = false
      }
    }
  },
}
